<div class="amp-dialog">
  <div class="amp-dialog-header mb-2">
    <div class="amp-dialog-title">Empresas</div>
    <span class="amp-dialog-close bi-x-lg" (click)="bsModalRef.hide()"></span>
  </div>

  <amp-company-selector class="amp-field-dropdown" [editMode]="true"></amp-company-selector>
</div>